/* eslint-disable react/require-default-props */
import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { TextField, Typography, Button } from '@one-thd/sui-atomic-components';
import { Formik } from 'formik';
import { TextSignup } from './TextSignup';
import { validateForm } from '../components/utils/OutOfStockUtil';
import { Row, Col } from '@thd-olt-component-react/grid';
import proptypes from 'prop-types';
const { string, bool, func, node } = proptypes
import { MESSAGE_STATES, DEFAULT_LEGAL_DISCLAIMER } from './constants';
import './out-of-stock.style.scss';

const OutOfStock = ({
  enableSms = false,
  legalDisclaimer = null,
  handleOnSubmit,
  status,
  updateState,
  buttonRef,
  oosMessageText
}) => {

  const customSMSOutOfStockDisclaimer = useConfigService('customSMSOutOfStockDisclaimer');
  // Use prop disclaimer text if provided, otherwise use custom config or default disclaimer
  const legalDisclaimerText = legalDisclaimer || customSMSOutOfStockDisclaimer || DEFAULT_LEGAL_DISCLAIMER;

  return (
    <Formik
      initialValues={{ email: '', sms: '' }}
      validate={(values) => validateForm(values, updateState, enableSms)}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(async () => {
          await handleOnSubmit({ values });
          setSubmitting(false);
        }, 400);
      }}
    >
      {(formikProps) => {
        const {
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting
        } = formikProps;
        return (
          <Row className="out-of-stock" data-component="TrackOutOfStock">
            <Col lg="12">
              <Typography variant="body-base">
                {oosMessageText}
              </Typography>
            </Col>
            <Col lg="12">
              {status && (
                <form
                  onSubmit={handleSubmit}
                >
                  <div className="sui-w-full sm:sui-max-w-72 sui-grid sui-grid-cols-1 sui-gap-y-6">
                    <TextField
                      onChange={handleChange}
                      id="email"
                      status={(errors.email ? 'error' : values.email && 'success')}
                      statusMessage={errors.email}
                      placeholder="name@homedepot.com"
                      value={values.email}
                      label="Email"
                      optional={enableSms}
                      fullWidth
                    />

                    {enableSms && (
                      <TextSignup
                        textValue={values.sms}
                        onChange={handleChange}
                        status={(errors.sms ? 'error' : values.sms && 'success')}
                        statusMessage={errors.sms}
                        optional
                      />
                    )}

                    <Button
                      ref={buttonRef}
                      aria-label="Submit"
                      disabled={isSubmitting}
                      type="submit"
                    >
                      Notify Me
                    </Button>
                  </div>
                </form>
              )}
              {status
                && (
                  <div className="out-of-stock__status">
                    <div className={`alert-inline alert-inline--${MESSAGE_STATES[status].alertClass}`}>
                      <span className="alert-inline__message" aria-live="polite">
                        <span className="alert-inline__title">{MESSAGE_STATES[status].title} </span>
                        {MESSAGE_STATES[status].message}
                      </span>
                    </div>
                  </div>
                )}
            </Col>
            {enableSms
              && (
                <Col lg="12">
                  <Typography variant="body-xs" height="tight">
                    {legalDisclaimerText}
                  </Typography>
                </Col>
              )}
          </Row>
        );
      }}
    </Formik>
  );
};

OutOfStock.displayName = 'OutOfStock';

OutOfStock.dataModel = {};

OutOfStock.propTypes = {
  enableSms: bool,
  legalDisclaimer: string,
  handleOnSubmit: func.isRequired,
  status: string.isRequired,
  updateState: func.isRequired,
  buttonRef: node.isRequired,
  oosMessageText: string.isRequired
};

export { OutOfStock };